/**
 * Stable CSS class names for E2E — ShippingCancelReason page and update drawer.
 * Containers use `shipping-cancel-reason__<element>`; inputs and
 * user-interactable controls use `shipping-cancel-reason-input--<name>`.
 */
export const SCRN = {
    page: 'shipping-cancel-reason-page',
    root: 'shipping-cancel-reason',

    header: 'shipping-cancel-reason__header',
    titleBox: 'shipping-cancel-reason__title-box',
    title: 'shipping-cancel-reason__title',
    headerActions: 'shipping-cancel-reason__header-actions',
    btnAdd: 'shipping-cancel-reason-input--button-add',

    loading: 'shipping-cancel-reason__loading',

    drawer: 'shipping-cancel-reason__drawer',
    grid: 'shipping-cancel-reason__grid',

    /* --- Grid cells ---------------------------------------------------- */
    cellReasonId: 'shipping-cancel-reason__cell-reason-id',
    cellReasonKey: 'shipping-cancel-reason__cell-reason-key',
    cellReasonKeyText: 'shipping-cancel-reason__cell-reason-key-text',
    cellReasonName: 'shipping-cancel-reason__cell-reason-name',
    cellReasonNameText: 'shipping-cancel-reason__cell-reason-name-text',
    cellIsActive: 'shipping-cancel-reason__cell-is-active',
    inputCellIsActiveSwitch: 'shipping-cancel-reason-input--cell-is-active-switch',
    cellIsDeleted: 'shipping-cancel-reason__cell-is-deleted',
    inputCellIsDeletedSwitch: 'shipping-cancel-reason-input--cell-is-deleted-switch',
    cellReasonPriorityId: 'shipping-cancel-reason__cell-reason-priority-id',
    cellEdit: 'shipping-cancel-reason__cell-edit',
    btnEdit: 'shipping-cancel-reason-input--button-edit',

    /* --- Update drawer ------------------------------------------------- */
    drawerRoot: 'shipping-cancel-reason__drawer-root',
    drawerHeader: 'shipping-cancel-reason__drawer-header',
    drawerTitleBox: 'shipping-cancel-reason__drawer-title-box',
    drawerTitle: 'shipping-cancel-reason__drawer-title',
    drawerCloseBox: 'shipping-cancel-reason__drawer-close-box',
    btnDrawerClose: 'shipping-cancel-reason-input--button-drawer-close',

    drawerForm: 'shipping-cancel-reason__drawer-form',
    drawerFieldReasonId: 'shipping-cancel-reason__drawer-field-reason-id',
    inputDrawerReasonId: 'shipping-cancel-reason-input--drawer-reason-id',
    drawerFieldReasonKey: 'shipping-cancel-reason__drawer-field-reason-key',
    inputDrawerReasonKey: 'shipping-cancel-reason-input--drawer-reason-key',
    drawerFieldPriority: 'shipping-cancel-reason__drawer-field-priority',
    inputDrawerPriority: 'shipping-cancel-reason-input--drawer-priority',
    drawerActiveGroup: 'shipping-cancel-reason__drawer-active-group',
    inputDrawerIsActiveLabel: 'shipping-cancel-reason__drawer-is-active-label',
    inputDrawerIsActive: 'shipping-cancel-reason-input--drawer-is-active',

    drawerInsertForm: 'shipping-cancel-reason__drawer-insert-form',
    drawerFieldInsertReasonKey: 'shipping-cancel-reason__drawer-field-insert-reason-key',
    inputDrawerInsertReasonKey: 'shipping-cancel-reason-input--drawer-insert-reason-key',

    drawerActions: 'shipping-cancel-reason__drawer-actions',
    btnDrawerSubmit: 'shipping-cancel-reason-input--button-drawer-submit',
    btnDrawerSubmitUpdate: 'shipping-cancel-reason-input--button-drawer-submit--update',
    btnDrawerSubmitInsert: 'shipping-cancel-reason-input--button-drawer-submit--insert',
} as const;

export const scrnCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
